import { render, staticRenderFns } from "./umeng-config.vue?vue&type=template&id=785b86fa"
import script from "./umeng-config.vue?vue&type=script&lang=js"
export * from "./umeng-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports